import { render, staticRenderFns } from "./DeviceVersionLog.vue?vue&type=template&id=51ac7496&"
import script from "./DeviceVersionLog.vue?vue&type=script&lang=js&"
export * from "./DeviceVersionLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports